/**
 * A person's dates, in the form the person page shows them.
 *
 * Only years are used. Watchmode dates are usually "YYYY-MM-DD" but are
 * sometimes just a year, and a full date adds nothing to a page whose job is
 * "which of these Brad Pitts did I mean".
 */
export function formatLifespan(dateOfBirth?: string, dateOfDeath?: string): string {
    const born = year(dateOfBirth);
    const died = year(dateOfDeath);

    if (born && died) return `${born} – ${died}`;
    if (born) return `Born ${born}`;
    // A death date with no birth date is rare but not impossible upstream.
    if (died) return `Died ${died}`;
    return "";
}

/** The year out of a date string, or undefined if there isn't a usable one. */
function year(date?: string): string | undefined {
    const match = date?.match(/^(\d{4})/);
    return match ? match[1] : undefined;
}
